import { render, staticRenderFns } from "./pictureComponent.vue?vue&type=template&id=1b6a1ea0&scoped=true"
import script from "./pictureComponent.vue?vue&type=script&lang=js"
export * from "./pictureComponent.vue?vue&type=script&lang=js"
import style0 from "./pictureComponent.vue?vue&type=style&index=0&id=1b6a1ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a1ea0",
  null
  
)

export default component.exports